/**
 * 獲取地址參數相關
 */
import { parse } from 'query-string';

const getQuery = () => {
  const query = parse(window.location.search);
  return query;
};

export default getQuery;
